<template>
  <!-- Oturum içi sayfa geçişi göstergesi: belirsiz (indeterminate) ince üst çubuk. Guard'ın
       beklediği iş (token yenileme + lisans + yetki kontrolü) önceden ölçülemez, bu yüzden
       yüzde YOK — GitHub/Linear/Vercel/YouTube/Gmail'in sayfa geçişinde kullandığı desen. -->
  <div class="nav-progress-track" role="progressbar" aria-label="Sayfa yükleniyor">
    <div class="nav-progress-bar"></div>
  </div>
</template>

<script>
export default {
  name: "NavProgressBar",
};
</script>

<style scoped>
.nav-progress-track {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  overflow: hidden;
  background: transparent;
  z-index: 20;
}

.nav-progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 40%;
  border-radius: 0 9999px 9999px 0;
  background: linear-gradient(90deg, #667eea, #764ba2);
  animation: nav-progress-slide 1.1s ease-in-out infinite;
}

@keyframes nav-progress-slide {
  0% {
    left: -40%;
    width: 40%;
  }
  50% {
    width: 60%;
  }
  100% {
    left: 100%;
    width: 40%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .nav-progress-bar {
    animation: none;
    left: 0;
    width: 100%;
    opacity: 0.6;
  }
}
</style>
